import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@ml/core/types/classes/user.class';
var SidenavComponent = /** @class */ (function () {
    function SidenavComponent(router) {
        this.router = router;
    }
    SidenavComponent.prototype.ngOnInit = function () {
        this.collapsed = false;
    };
    SidenavComponent.prototype.isOptionVisible = function (option) {
        return option.role.indexOf(this.user.role) >= 0;
    };
    Object.defineProperty(SidenavComponent.prototype, "collapsedIcon", {
        get: function () {
            return this.collapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left';
        },
        enumerable: true,
        configurable: true
    });
    SidenavComponent.prototype.onClickOption = function (link) {
        // let queryParamsHandling: QueryParamsHandling = '';
        // const url = this.router.url;
        // if (url.split('/')[1].startsWith(link)) {
        //   queryParamsHandling = 'preserve';
        // }
        this.router.navigate([link]);
    };
    return SidenavComponent;
}());
export { SidenavComponent };
